const SEARCH_VARS = window.search;
if(!SEARCH_VARS.id) {
    console.warn("Missing search ID")
}
if(!SEARCH_VARS.api) {
    console.warn("Missing search API key")
}
if(!SEARCH_VARS.products) {
    console.warn("Missing search products index")
}
const shared = {
    "app_id" : SEARCH_VARS.id,
    "api_key": SEARCH_VARS.api
};

const productsConfig = {
   ...shared,
   "index" : SEARCH_VARS.products,
    "facets": [
        'productType'
    ]
};

const siteConfig = {
  ...shared,
    "index" : SEARCH_VARS.site,
};


export { productsConfig, siteConfig }
